import dayjs, { extend, locale } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import de from 'dayjs/locale/de'

extend(utc)
extend(timezone)
locale(de)

const tz = 'Europe/Berlin'

export function useDate() {
  function getTimezoneDate(date: Date | string) {
    const dayjsLocal = dayjs(date)
    const dayjsGermany = dayjsLocal.tz(tz, true)
    return dayjsGermany
  }

  function formatDate(date: Date | string, format: string) {
    const timezoneDate = getTimezoneDate(date)
    return timezoneDate.format(format)
  }

  function isEqualDate(date: Date | string, comp: Date | string) {
    return dayjs(date).isSame(comp)
  }

  function differenceInBusinessDays(date: Date | string, comp: Date | string) {
    const date1 = dayjs(date)
    const date2 = dayjs(comp)
    const diff = Math.round(date1.diff(date2, 'days', true))
    return diff
  }

  return {
    formatDate,
    isEqualDate,
    differenceInBusinessDays
  }
}
